<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Transaction Report</div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid" class="px-2">
            <v-row class="px-2">
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.datetype"
                  :items="txnDateType"
                  :rules="FieldRequired('Date Type')"
                  placeholder="Select Filter Date Type"
                  label="Select Filter Date Type"
                  outlined
                  dense
                  class="rounded"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.fromdate"
                  label="From Date"
                  :rules="FieldRequired('From Date')"
                  @input="filterList.fromdate"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.todate"
                  type="date"
                  :rules="FieldRequired('To Date')"
                  label="To Date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  class="rounded"
                  v-model="filterList.sendingagentid"
                  dense
                  outlined
                  :rules="FieldRequired('Channel Partner')"
                  label="Channel Partner"
                  item-text="txt"
                  item-value="val"
                  :items="senderPartners"
                  placeholder="Channel Partner"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.txnsstatus"
                  class="rounded"
                  :rules="FieldRequired('Transaction Status')"
                  label="Transaction Status"
                  dense
                  outlined
                  :items="txnStatusReports"
                  placeholder="Transaction Status"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.destinationagent"
                  class="rounded"
                  :rules="FieldRequired('Payout Partner')"
                  label="Payout Partner"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="payoutPartner"
                  @input="FilterpartnerPaymentMode(filterList.destinationagent)"
                  placeholder="Payout Partner"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.paymenttype"
                  class="rounded"
                  :rules="FieldRequired('Payment Mode')"
                  label="Payment Mode"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="method_options"
                  placeholder="Payment Mode"
                ></v-autocomplete>
              </v-col>
              <v-btn
                depressed
                @click="getReportResults()"
                class="mr-2 mt-1"
                color="primary"
                small
                >Get Results
              </v-btn>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-row class="ma-1 px-2 mt-2">
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class="mt-1"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Type here to filter values."
          hide-details
          rounded
          outlined
          dense
          clearable
          class="mt-2"
        ></v-text-field> -->
      </v-row>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :search="search"
        :loading="loaderOverlay"
        loading-text="Loading please wait...."
        no-data-text="No data available."
        item-key="Pin_Number"
        dense
        class="mt-3"
      >
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { FieldRequired } from "@/utils/validation.js";
import alerts from "@/mixins/alerts";
import partnerService from "@/services/partnerService/partnerService.js";
import reportingService from "@/services/ReportingService/reportingService.js";
import {
  txnDateType,
  txnStatusReports,
} from "@/utils/ConstantDropdowns/index.js";
export default {
  mixins: [alerts],
  name: "Transaction Report",
  data: () => {
    return {
      FieldRequired,
      txnStatusReports: txnStatusReports,
      txnDateType: txnDateType,
      headers: [],
      totalpayoutPartnerDetails: [],
      filterList: {
        datetype: "1",
        fromdate: new Date().toISOString().substr(0, 10),
        todate: new Date().toISOString().substr(0, 10),
        destinationagent: "All",
        txnsstatus: "All",
        paymenttype: "All",
        sendingagentid: "All",
      },
      userList: [],
      senderPartners: [],
      payoutPartner: [],
      method_options: [
        {
          txt: "All",
          val: "All",
        },
      ],
      search: "",
      userSelectedFilter: "Customer ID",
      loaderOverlay: false,
      valid: false,
    };
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },

  mounted() {
    this.getAllSendPartners();
    this.getpayoutpartBysendingpart();
  },

  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(
          this.headers,
          this.userList,
          "V3 Transaction Report",
        );
      }
    },
    FilterpartnerPaymentMode(partner_code) {
      this.totalpayoutPartnerDetails.map((ele) => {
        if (ele.partner_code == partner_code) {
          this.partnerPaymentMode(ele.partner_id);
        }
      });
    },
    async partnerPaymentMode(parent_partner_id) {
      try {
        const response = await partnerService.getAllPaymentsbyPartnerId(
          parent_partner_id,
        );
        if (response.data.status_code === 200) {
          this.method_options = response.data.data.map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
          this.method_options.unshift({
            txt: "All",
            val: "All",
          });
        } else {
          this.method_options = [];
        }
        console.log("Payment Modes", response);
      } catch (e) {
        console.error(e);
      }
    },
    async getpayoutpartBysendingpart(partner_id) {
      try {
        const responseData = await partnerService.getpayoutpartBysendingpart({
          partner_id: partner_id,
        });
        if (responseData.data.status_code === 200) {
          this.totalpayoutPartnerDetails = responseData.data.data;
          this.payoutPartner = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
          this.payoutPartner.unshift({
            txt: "All",
            val: "All",
          });
        }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getAllSendPartners() {
      try {
        const responseData = await partnerService.getAllSenderPartners();
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
          this.senderPartners.unshift({
            txt: "All",
            val: "All",
          });
        }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getReportResults() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const response = await reportingService.v2TransactionReport(
            this.filterList,
          );
          if (response.status === 200) {
            this.loaderOverlay = false;
            const ObjKeys = Object.keys(response.data.data[0]);
            this.headers = ObjKeys.map((ele) => {
              return {
                text: ele,
                value: ele,
                sortable: false,
              };
            });
            this.userList = response.data.data;
          } else {
            this.loaderOverlay = false;
          }
        } catch (error) {
          this.loaderOverlay = false;
          console.error(error);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
